export default "<div [matTooltip]=\"displayValue\" [matTooltipDisabled]=\"!isTooltip\">\n\t<span>{{ displayValue }}</span>\n</div>";